import { useEffect, useState } from 'react'
import { Document, Page } from 'react-pdf'

import { Spinner } from '@/components/ui/spinner'
import { PDF_RESOURCE_OPTIONS } from '@/lib/pdf-config'

type Props = {
  url: string
  pageNumber: number
  /** 表示枠の高さ (px)。ページはこの高さと横幅の両方に収まるよう縮める */
  height: number
  onLoad: (numPages: number) => void
  onError: () => void
}

const Loading = () => (
  <div className="flex h-full items-center justify-center">
    <Spinner size={20} />
  </div>
)

/** メモ内の PDF を 1 ページずつ表示する。react-pdf を重くしないよう遅延 import で使う */
const PdfPreview = ({ url, pageNumber, height, onLoad, onError }: Props) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const [width, setWidth] = useState(0)
  // ページの 幅 / 高さ。分かるまでは高さ基準で描く
  const [aspect, setAspect] = useState<number | null>(null)

  useEffect(() => {
    if (!container) return
    setWidth(container.clientWidth)
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width))
    observer.observe(container)
    return () => observer.disconnect()
  }, [container])

  const pageWidth = aspect ? Math.min(width, height * aspect) : undefined

  return (
    <div ref={setContainer} className="flex h-full w-full items-center justify-center overflow-hidden">
      {width > 0 && (
        <Document
          file={url}
          options={PDF_RESOURCE_OPTIONS}
          loading={<Loading />}
          error={null}
          onLoadSuccess={(pdf) => onLoad(pdf.numPages)}
          onLoadError={onError}
        >
          <Page
            pageNumber={pageNumber}
            width={pageWidth}
            height={pageWidth ? undefined : height}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            loading={<Loading />}
            onLoadSuccess={(page) => setAspect(page.originalWidth / page.originalHeight)}
          />
        </Document>
      )}
    </div>
  )
}

export default PdfPreview
